import { render } from "./DeliveriesList.vue?vue&type=template&id=35e4f87b&scoped=true"
import script from "./DeliveriesList.vue?vue&type=script&lang=js"
export * from "./DeliveriesList.vue?vue&type=script&lang=js"

import "./DeliveriesList.vue?vue&type=style&index=0&id=35e4f87b&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35e4f87b"]])

export default __exports__